// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  login: '/login',
  logout: '/logout',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  index: path(ROOTS_DASHBOARD, '/index'),
  request: {
    root: path(ROOTS_DASHBOARD, '/request'),
    list: path(ROOTS_DASHBOARD, '/request/list'),
    detail: (id) => path(ROOTS_DASHBOARD, `/request/detail/${id}`),
    newRequest: path(ROOTS_DASHBOARD, '/request/new-request'),
    edit: path(ROOTS_DASHBOARD, '/request/edits'),
  },
  slider: {
    root: path(ROOTS_DASHBOARD, '/slider'),
    list: path(ROOTS_DASHBOARD, '/slider/list'),
    detail: (id) => path(ROOTS_DASHBOARD, `/slider/detail/${id}`),
    edit: (id) => path(ROOTS_DASHBOARD, `/slider/edit/${id}`),
    create: path(ROOTS_DASHBOARD, '/slider/create'),
  },
  banner: {
    root: path(ROOTS_DASHBOARD, '/banner'),
    list: path(ROOTS_DASHBOARD, '/banner/list'),
    detail: (id) => path(ROOTS_DASHBOARD, `/banner/detail/${id}`),
    edit: (id) => path(ROOTS_DASHBOARD, `/banner/edit/${id}`),
    create: path(ROOTS_DASHBOARD, '/banner/create'),
  },
  feature: {
    root: path(ROOTS_DASHBOARD, '/feature'),
    list: path(ROOTS_DASHBOARD, '/feature/list'),
    detail: (id) => path(ROOTS_DASHBOARD, `/feature/detail/${id}`),
    edit: (id) => path(ROOTS_DASHBOARD, `/feature/edit/${id}`),
    create: path(ROOTS_DASHBOARD, '/feature/create'),
  },
  tag: {
    root: path(ROOTS_DASHBOARD, '/tag'),
    list: path(ROOTS_DASHBOARD, '/tag/list'),
    detail: (id) => path(ROOTS_DASHBOARD, `/tag/detail/${id}`),
    edit: (id) => path(ROOTS_DASHBOARD, `/tag/edit/${id}`),
    create: path(ROOTS_DASHBOARD, '/tag/create'),
  },
  gallery: {
    root: path(ROOTS_DASHBOARD, '/gallery'),
  },

  webinar: {
    root: path(ROOTS_DASHBOARD, '/webinar'),
    all: path(ROOTS_DASHBOARD, '/webinar/all'),
    detail: (id) => path(ROOTS_DASHBOARD, `/webinar/detail/${id}`),
    newRequests: path(ROOTS_DASHBOARD, '/webinar/new-requests'),
    edit: path(ROOTS_DASHBOARD, '/webinar/edits'),
    onboard: path(ROOTS_DASHBOARD, '/webinar/onboard'),
    conductor: path(ROOTS_DASHBOARD, '/webinar/conductor'),
  },
  recommendation: {
    tag: {
      list: path(ROOTS_DASHBOARD, '/recommendation/tag/list'),
      create: path(ROOTS_DASHBOARD, '/recommendation/tag/create'),
      edit: path(ROOTS_DASHBOARD, '/recommendation/tag/edit'),
    },
    question: {
      list: path(ROOTS_DASHBOARD, '/recommendation/question/list'),
      create: path(ROOTS_DASHBOARD, '/recommendation/question/create'),
      edit: path(ROOTS_DASHBOARD, '/recommendation/question/edit'),
    },
    conflict: {
      list: path(ROOTS_DASHBOARD, '/recommendation/conflict/list'),
      create: path(ROOTS_DASHBOARD, '/recommendation/conflict/create'),
      edit: path(ROOTS_DASHBOARD, '/recommendation/conflict/edit'),
    },
    relation: {
      list: path(ROOTS_DASHBOARD, '/recommendation/relation/list'),
      edit: path(ROOTS_DASHBOARD, '/recommendation/relation/edit'),
    },
  },
};
